import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { GET_COUNTRIES } from "../graphql/Queries/CountryQuery";
import { Preload } from "../components/Preload";
import { DELETE_COUNTRY } from "../graphql/Mutations/CoutryMutation";

export const Countries = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { data } = useQuery(GET_COUNTRIES, {
    fetchPolicy: "no-cache",
  });
  const [removeCountry] = useMutation(DELETE_COUNTRY);

  useEffect(() => {
    if (data) {
      setItems(data.countries);
    }
  }, [data]);

  const remove = (id) => {
    removeCountry({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteCountry);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle title={"Страны"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
